import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { RouteGuard } from './route.guard';

export abstract class CompositeGuard implements RouteGuard {
  constructor(private guards: RouteGuard[]) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    for (const guard of this.guards) {
      const canActivate = await guard.canActivate(route, state);
      if (!canActivate) {
        return false;
      }
    }

    return true;
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    for (const guard of this.guards) {
      const canActivate = await guard.canActivateChild(childRoute, state);
      if (!canActivate) {
        return false;
      }
    }

    return true;
  }
}
